/* @refresh reset */
import React from 'react';
import { AuthenticationContextProvider } from './homeModules/auth/contexts/AuthenticationContext';
import { DeleteConfirmationModalContextProvider } from './sharedModules/contexts/DeleteConfirmationModalContext';
import { EquipmentCostsContextProvider } from './salesEstimateModules/costSettings/contexts/EquipmentCostsContext';
import { InstallationCostsContextProvider } from './salesEstimateModules/costSettings/contexts/InstallationCostsContext';
import { RebatesContextProvider } from './salesEstimateModules/adminSettings/contexts/RebatesContext';
import { SystemAccessoriesContextProvider } from './salesEstimateModules/adminSettings/contexts/SystemAccessoriesContext';
import { EstimateCostsContextProvider } from './salesEstimateModules/estimateCosts/contexts/EstimateCostsContext';
import { EstimateCustomersContextProvider } from './salesEstimateModules/estimateCustomers/contexts/EstimateCustomersContext';
import { EstimateDetailsContextProvider } from './salesEstimateModules/estimateDetails/contexts/EstimateDetailsContext';
import { EstimateRebatesContextProvider } from './salesEstimateModules/estimateRebates/contexts/EstimateRebatesContext';
import { UsersContextProvider } from './adminModules/users/contexts/UsersContext';
import { SnackBarContextProvider } from './sharedModules/form/contexts/SnackBarContext';
import { ChillerLogsContextProvider } from './chillerModules/chillerLogs/contexts/ChillerLogsContext';
import { LocationProvider } from './chillerModules/contexts/LocationContext';

interface ContextsProviderProps {
  children: React.ReactNode;
}

const ContextsProvider: React.FC<ContextsProviderProps> = ({ children }) => {
  return (
    <AuthenticationContextProvider>
      <SnackBarContextProvider>
        <EquipmentCostsContextProvider>
          <InstallationCostsContextProvider>
            <RebatesContextProvider>
              <SystemAccessoriesContextProvider>
                <EstimateCostsContextProvider>
                  <EstimateCustomersContextProvider>
                    <EstimateDetailsContextProvider>
                      <EstimateRebatesContextProvider>
                        <UsersContextProvider>
                          <ChillerLogsContextProvider>
                            <LocationProvider>
                              <DeleteConfirmationModalContextProvider>
                                <>{children}</>
                              </DeleteConfirmationModalContextProvider>
                            </LocationProvider>
                          </ChillerLogsContextProvider>
                        </UsersContextProvider>
                      </EstimateRebatesContextProvider>
                    </EstimateDetailsContextProvider>
                  </EstimateCustomersContextProvider>
                </EstimateCostsContextProvider>
              </SystemAccessoriesContextProvider>
            </RebatesContextProvider>
          </InstallationCostsContextProvider>
        </EquipmentCostsContextProvider>
      </SnackBarContextProvider>
    </AuthenticationContextProvider>
  );
};

export default ContextsProvider;
